import { useToast } from '@/store/toast';

/** Место, где рисуется короткое сообщение. Одно на всё приложение. */
export function ToastHost() {
  const text = useToast((s) => s.text);
  const action = useToast((s) => s.action);
  const hide = useToast((s) => s.hide);
  if (!text) return null;
  return (
    <div className="toast" role="status" aria-live="polite">
      {text}
      {action && (
        <button type="button" className="toast-act" onClick={() => { hide(); action.run(); }}>{action.label}</button>
      )}
    </div>
  );
}
